<template>
  <data-list :payload="currencyObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination"></data-list>
</template>
<script>
import DataList from '../../components/DataList.vue'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      currencyObj: {
        isHeader: true,
        isHideAdd: false,
        selection: [],
        showSelect: true,
        addNewRoute: () => this.$router.push(this.routeURL),
        list: [],
        loading: true,
        page: 1,
        editProp: 'currencylist_name',
        editURL: (item) => `${this.routeURL}/${item.id}`
      },
      total: 0,
      routeURL: '/currencies/actions',
      pagination: !this.$formatter.isEmptyObject(this.$store.state.CURRENCY_INDEX) ? this.$store.state.CURRENCY_INDEX : { sortBy: ['validfrom'], itemsPerPage: 25, sortDesc: [true], search: '' },
      MODULE_URL: 'currencies'
    }
  },
  components: {
    DataList
  },
  computed: {
    ...mapState(['CURRENCY_INDEX']),
    headers () {
      let headers = [{
        text: '#',
        value: 'id',
        width: '10%'
      }, {
        text: this.$t('message.customer.name'),
        value: 'currencylist_name',
        width: '40%'
      }, {
        text: `${this.$t('message.currency.exchangeRate')}`,
        value: 'exchangerate',
        width: '25%'
      }, {
        text: `${this.$t('message.currency.validFrom')}`,
        value: 'validfrom',
        width: '40%'
      }]
      return headers
    }
  },
  watch: {
    pagination (val) {
      let model = { type: 'CURRENCY_INDEX', data: val }
      this.$store.commit('rememberOrder', model)
      this.getListHandler()
    },
    search (val) {
      this.getListHandler()
    }
  },
  mounted () {
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE_URL) {
        let payload = { ids: data.ids, url: `${this.MODULE_URL}/delete_multiple`, module: this.MODULE_URL }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE_URL) {
        this.currencyObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
  },
  methods: {
    getListHandler () {
      this.currencyObj.loading = true
      this.currencyObj.module = this.MODULE_URL
      let fields = this.$formatter.cloneVariable(this.headers)
      let { page, search, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      let queryFields = fields
      queryFields.splice(1, 1)
      let result = queryFields.find(x => x.value === sortBy[0])
      let pageVal = page || 1
      let query = {
        'expand': [{
          'Model': 'CurrencyList',
          'on_field': 'Id',
          'on_parent_field': 'CurrencyId',
          'select': ['name'],
          filter: `name contains '${search}'`,
          order_by: {
            'field': sortBy[0] === 'currencylist_name' ? 'name' : null,
            'asc_or_desc': sortBy[0] === 'currencylist_name' ? sortDesc[0] ? 'desc' : 'asc' : null
          }
        }],
        'order_by': {
          'field': result ? result.value : null,
          'asc_or_desc': sortDesc[0] ? 'desc' : 'asc'
        },
        'skip': ((pageVal - 1) * itemsPerPage),
        'limit': itemsPerPage,
        'include_count': true,
        'filter': `${queryFields.map(x => x.value).join(` contains '${search || ''}' OR `)} contains '${search || ''}'`
      }
      this.$_executeApi('post', `${this.MODULE_URL}/query`, query)
        .then((response) => {
          let { values, count } = response.data
          let transformData = { number: { list: ['exchangerate'], format: 'replaceDotWithComma' }, date: { list: ['validfrom'], from: 'DD.MM.YYYY', to: 'DD.MM.YYYY' } }
          let modelList = this.$_formatListModel(values, transformData)
          this.currencyObj.loading = false
          this.currencyObj.list = modelList
          this.total = count
          if (this.pagination.page > 1 && this.total <= this.pagination.itemsPerPage * (this.pagination.page - 1)) {
            this.pagination.page = 1
            this.currencyObj.page = 1
          }
        })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
  }
}
</script>
